import { Controller } from "@hotwired/stimulus"

// Per-bank cascade for "Sync all".
//
// The server syncs every bank inside one blocking POST and answers with a
// redirect, so there is no progress to stream. What it does guarantee is the
// ORDER: sync_all walks PlaidItem.find_each, which is id ascending, the same
// order the rows are rendered in. So the cascade lights the right bank next —
// only the moment each one lights up is estimated.
//
// The last row is deliberately never marked done: it stays "syncing" until the
// redirect replaces the page, so the screen never claims a result the server
// has not returned yet.
export default class extends Controller {
  static targets = ["row", "tab", "label", "bar"]
  static values = { step: { type: Number, default: 1100 } }

  connect() {
    this.timers = []
  }

  disconnect() {
    this.#clear()
  }

  // Fires on the tab's form submit, so a cooldown-locked tab (which is not a
  // form at all) can never start the cascade.
  start() {
    this.#clear()

    const rows = this.rowTargets.filter((row) => row.dataset.syncable === "true")
    if (rows.length === 0) return

    if (this.hasTabTarget) this.tabTarget.dataset.running = "true"
    rows.forEach((row) => { row.dataset.syncState = "queued" })

    rows.forEach((row, index) => {
      this.timers.push(
        setTimeout(() => {
          if (index > 0) rows[index - 1].dataset.syncState = "done"
          row.dataset.syncState = "active"
          this.#label(`${index + 1} / ${rows.length}`)
          // Half a notch short of the bank in flight: it is not confirmed yet.
          this.#progress((index + 0.5) / rows.length)
        }, index * this.stepValue)
      )
    })
  }

  #label(text) {
    if (!this.hasLabelTarget) return

    this.labelTarget.textContent = text
    this.labelTarget.classList.remove("is-swapping")
    void this.labelTarget.offsetWidth // restart the animation
    this.labelTarget.classList.add("is-swapping")
  }

  #progress(fraction) {
    if (this.hasTabTarget) this.tabTarget.style.setProperty("--p", fraction)
  }

  #clear() {
    this.timers.forEach(clearTimeout)
    this.timers = []
  }
}
